import { COLUMNS, data } from './partten';
import infoModel from './info.vue';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      COLUMNS,
      data: data,
      infoShow: false,
      form: {
        organizationId: '1'
      },
      organizationlist: [{
        id: '1',
        name: '泛华保险服务集团'
      }]
    };
  },
  methods: {
    getDataFun() {},
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleInfo() {
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoForm.init();
      });
    },
    handleOk(arr) {
      console.log(arr);
      this.data = this.data.concat(arr);
      console.log(this.data);
    },
    handleExport() {
      window.location.href = 'http://test.home.console.insurforce.cn/excel/' + this.$t('经纪再保险') + '.xlsx';
    }
  }
};